import axios from 'axios';

import config from '@/config';

export const GLSAxios = (region: string) => {
  const baseURL = config.fgp.host[region];

  const instance = axios.create({
    baseURL,
  });

  return instance;
};
